import Router from './pages/router';
import s from './assets/styles/main.module.scss';

const App = () => (
    <main className={s.main}>
      <Router />
    </main>
);
export default App;
